import AddIcon from '@mui/icons-material/Add';
import { Box } from '@mui/material';
import React from 'react';
import './index.scss';

export interface SavedView {
  id: string;
  label: string;
  /** Optional result count shown in DM Mono at 75% opacity. */
  count?: number;
}

interface SavedViewsBarProps {
  views: SavedView[];
  activeViewId: string;
  onSelect: (id: string) => void;
  /** Optional "Save current" affordance. Hidden when omitted. */
  onSaveCurrent?: () => void;
}

/**
 * Preset views over the existing server-side filters — presentational only.
 * Each page owns its view definitions and applies the matching filter values
 * in `onSelect`; this component adds no new filter params.
 */
const SavedViewsBar: React.FC<SavedViewsBarProps> = ({
  views,
  activeViewId,
  onSelect,
  onSaveCurrent,
}) => {
  if (!views.length) return null;

  return (
    <Box className="cc-views" role="tablist" aria-label="Saved views">
      <span className="cc-views__label">Views</span>
      {views.map((view) => {
        const active = view.id === activeViewId;
        return (
          <button
            key={view.id}
            type="button"
            role="tab"
            aria-selected={active}
            className={`cc-views__pill${active ? ' is-active' : ''}`}
            onClick={() => onSelect(view.id)}
          >
            {view.label}
            {view.count !== undefined && (
              <span className="cc-views__count">
                {view.count.toLocaleString('en-IN')}
              </span>
            )}
          </button>
        );
      })}
      {onSaveCurrent && (
        <button
          type="button"
          className="cc-views__save"
          onClick={onSaveCurrent}
        >
          <AddIcon className="cc-views__save-icon" />
          Save current
        </button>
      )}
    </Box>
  );
};

export default SavedViewsBar;
